import { render, staticRenderFns } from "./providers.vue?vue&type=template&id=b958a11a&scoped=true"
import script from "./providers.vue?vue&type=script&lang=js"
export * from "./providers.vue?vue&type=script&lang=js"
import style0 from "./providers.vue?vue&type=style&index=0&id=b958a11a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b958a11a",
  null
  
)

export default component.exports